import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import Webcam from 'react-webcam';
import _ from 'lodash';
import window from 'global/window';
import useStores from 'shared/hooks/use-stores';
import { SmallLoader, Button } from 'shared/components';
import { ModalClose } from 'shared/modals';
import { ModalContainer } from 'shared/modals/v2-container';
import CameraIconWhite from 'shared/assets/camera-icon-white';
import RotateImageIcon from 'shared/assets/rotate-device-icon';
var desktop = window.innerHeight > 900 || window.innerWidth > 1000;
var smallPhone = window.innerWidth < 330 || window.innerHeight < 330;
var height = desktop ? 350 : smallPhone ? 240 : 287; // eslint-disable-line
var width = desktop ? 520 : smallPhone ? 335 : 472; // eslint-disable-line

var modalContainerStyles = css([".rotate-content{display:none;}", " ", ""], function (props) {
  return !desktop && !props.landscape && "\n    .ReactModal__Content {\n      background-color: #fff;\n      .upload-content {\n        width: 100vw;\n        overflow: hidden;\n        opacity: 0;\n        visibility: hidden;\n      }\n      .rotate-content {\n        display: block;\n        opacity: 1;\n        visibility: visible;\n        transition: opacity 0.2s;\n      }\n    }\n  ";
}, function (props) {
  return !desktop && props.landscape && "\n    .ReactModal__Content {\n      background-color: #fff;\n      width: 100vw;\n      min-height: 100vh;\n      .upload-content {\n        opacity: 1;\n        visibility: visible;\n        transition: opacity 0.2s;\n      }\n      .rotate-content {\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  ";
});
var PhotoIdCapture = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var handleCameraUpload = _ref.handleCameraUpload,
    onRequestClose = _ref.onRequestClose,
    containerProps = _ref.containerProps;
  var _useStores = useStores(),
    UI = _useStores.UI;
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(false),
    landscape = _useState2[0],
    setLandscape = _useState2[1];
  var webcam = useRef(null);
  function resize() {
    setLandscape(window.innerHeight < window.innerWidth);
  }
  useEffect(function () {
    window.addEventListener('resize', resize);
    return function () {
      window.removeEventListener('resize', resize);
    };
  });
  function capture() {
    handleCameraUpload(webcam.current.getScreenshot());
    onRequestClose();
  }
  function onUserMediaError(e) {
    console.log('user media error', e);
    setLoading(false);
    UI.showErnie("Unfortunately we are unable to access your camera. Please use the 'Upload a file' feature.", 'danger');
    _.delay(onRequestClose, 1500);
  }
  function close() {
    onRequestClose();
    setLoading(true);
  }
  return __jsx(ModalContainer, _extends({
    ref: ref,
    isOpen: true,
    p: desktop ? '47px' : '17px 27px',
    onRequestClose: close,
    landscape: landscape
  }, containerProps), __jsx(InnerContainer, null, __jsx("div", {
    className: "upload-content"
  }, __jsx(Text, null, "Line up your ID inside the window below"), __jsx(VideoContainer, null, loading && __jsx(SmallLoader, {
    height: 50
  }), __jsx(Webcam, {
    audio: false,
    height: height,
    ref: webcam,
    screenshotFormat: "image/jpeg",
    width: width,
    onUserMedia: function onUserMedia() {
      return setLoading(false);
    },
    onUserMediaError: onUserMediaError,
    videoConstraints: {
      facingMode: 'environment'
    },
    style: WebcamStyles // eslint-disable-line
    ,
    screenshotQuality: 1
  }))), __jsx(RotateContainer, {
    className: "rotate-content"
  }, __jsx(RotateImageIcon, null), __jsx(RotateText, null, "Rotate your Phone to snap a photo of your ID.")), __jsx(ButtonContainer, {
    className: "upload-content"
  }, __jsx(StyledButton, {
    height: desktop ? '58px' : '100px',
    width: desktop ? '118px' : '100px',
    onClick: capture,
    inverted: !desktop,
    "aria-label": "Take photo"
  }, __jsx(CameraIcon, null)))), __jsx(ModalClose, {
    onClick: close
  }));
});
export default PhotoIdCapture;
var RotateContainer = styled.div.withConfig({
  displayName: "photo-id-capture__RotateContainer",
  componentId: "sc-13bll3t-0"
})(["position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
var RotateText = styled.p.withConfig({
  displayName: "photo-id-capture__RotateText",
  componentId: "sc-13bll3t-1"
})(["font-size:24px;line-height:1.46;color:#6d747b;max-width:255px;"]);
var InnerContainer = styled.div.withConfig({
  displayName: "photo-id-capture__InnerContainer",
  componentId: "sc-13bll3t-2"
})(["display:flex;flex-direction:column;align-items:center;justify-content:flex-start;", ""], !desktop && "\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    height: 100%;\n    width: 100%;\n  ");
var Text = styled.p.withConfig({
  displayName: "photo-id-capture__Text",
  componentId: "sc-13bll3t-3"
})(["font-size:14px;color:#6d747b;text-align:center;margin-bottom:21px;"]);
var VideoContainer = styled.div.withConfig({
  displayName: "photo-id-capture__VideoContainer",
  componentId: "sc-13bll3t-4"
})(["position:relative;height:", "px;width:", "px;max-width:90vw;margin-bottom:25px;display:flex;align-items:center;justify-content:center;", " video{max-width:90vw;}"], height, width, !desktop && "\n    margin-bottom: 10px;\n  ");
var ButtonContainer = styled.div.withConfig({
  displayName: "photo-id-capture__ButtonContainer",
  componentId: "sc-13bll3t-5"
})(["display:flex;flex-direction:row;align-items:center;"]);
var StyledButton = styled(Button).withConfig({
  displayName: "photo-id-capture__StyledButton",
  componentId: "sc-13bll3t-6"
})(["", ""], !desktop && "\n    border-radius: 100px;\n    border: 3px solid #3989cf;\n    background-color: #4597e0;\n  ");
var WebcamStyles = {
  borderRadius: '5px',
  position: 'absolute',
  top: 0,
  left: 0,
  objectFit: 'cover'
};
var CameraIcon = styled(CameraIconWhite).withConfig({
  displayName: "photo-id-capture__CameraIcon",
  componentId: "sc-13bll3t-7"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", ""], !desktop && "\n    height: 35px;\n  ");